import type { ComponentChildren } from 'preact';
import type { State, Store } from '../state/store';

/** A collapsible sidebar section. Collapse state persists across loads. */
export function Section(
  { id, title, extra, store, state, children }:
  { id: string; title: string; extra?: ComponentChildren; store: Store; state: State;
    children: ComponentChildren },
) {
  const closed = state.collapsed.includes(id);
  return (
    <section class={closed ? 'closed' : ''} data-testid={`section-${id}`}>
      <h2 onClick={() => store.set({
        collapsed: closed ? state.collapsed.filter((x) => x !== id) : [...state.collapsed, id],
      })}>
        <span>{title}</span>
        {extra}
        <i>{closed ? '\u25b8' : '\u25be'}</i>
      </h2>
      {!closed && <div class="sec-b">{children}</div>}
    </section>
  );
}
